import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types'

const AgreementCheck = ({ handleChange }) =>
{
  const { t } = useTranslation();
  const { productUrls } = useSelector((state) => state.activation);
  const [message, setMessage] = useState(t('widget.checkboxAgreement.agreementCheck'))

  /**
   * useEffect hook for setting the links in the acknowledgment statement dynamically
   */
  useEffect(() =>
  {
    let msg = message
    let search = '<a target="_blank">'
    msg = msg.replace(RegExp("^(?:.*?<a target=\"_blank\">){" + 1 + "}"), function (x) { return x.replace(RegExp(search + "$"), `<a target="_blank" href=${productUrls.termsAndConditions}>`) })
    msg = msg.replace(RegExp("^(?:.*?<a target=\"_blank\">){" + 1 + "}"), function (x) { return x.replace(RegExp(search + "$"), `<a target="_blank" href=${productUrls.privacyStatement}>`) })
    msg = msg.replace(RegExp("^(?:.*?<a target=\"_blank\">){" + 1 + "}"), function (x) { return x.replace(RegExp(search + "$"), `<a target="_blank" href=${productUrls.cookieInformation}>`) })
    setMessage(msg)
  }, [])
  return (
    <div className="form-group">
      <label htmlFor="agreementCheck">
        <input
          type="checkbox"
          id="agreementCheck"
          style={{ marginRight: "8px", verticalAlign: "sub" }}
          onChange={(e) => handleChange("agreementCheck", e.target.checked)}
        />
        <span dangerouslySetInnerHTML={{ __html: message }}></span>
      </label>
    </div>
  );
};

AgreementCheck.propTypes = {
  handleChange: PropTypes.func
};

export default AgreementCheck;